export default __webpack_public_path__ + "player-section.png";